import Index from '@tunnel-components/@pages/supervision/camera/settings/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/camera/settings/index.ts